import { render, staticRenderFns } from "./hot-offer-item.vue?vue&type=template&id=3ecbfcd9&scoped=true&"
import script from "./hot-offer-item.vue?vue&type=script&lang=ts&"
export * from "./hot-offer-item.vue?vue&type=script&lang=ts&"
import style0 from "./hot-offer-item.vue?vue&type=style&index=0&id=3ecbfcd9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecbfcd9",
  null
  
)

export default component.exports